(function () {
  if (window.__czfx) return; window.__czfx = true;
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('cz-js');
  if (root.classList.contains('shopify-design-mode')) root.classList.add('cz-edit');
  if (reduce) root.classList.add('cz-reduce');

  function init() {
    var groups = new Map();
    d.querySelectorAll('.cz-reveal').forEach(function (el) {
      var p = el.parentElement; var i = groups.get(p) || 0; groups.set(p, i + 1);
      if (!el.style.getPropertyValue('--cz-d')) el.style.setProperty('--cz-d', (Math.min(i, 6) * 90) + 'ms');
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    d.querySelectorAll('.cz-reveal, .cz-split').forEach(function (el) { io.observe(el); });

    d.querySelectorAll('.cz-split').forEach(function (h) {
      if (h.dataset.split) return; h.dataset.split = 1;
      var walk = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (c) {
          if (c.nodeType === 3) {
            var frag = d.createDocumentFragment();
            c.textContent.split(/(\s+)/).forEach(function (w) {
              if (!w) return;
              if (/^\s+$/.test(w)) { frag.appendChild(d.createTextNode(w)); return; }
              var o = d.createElement('span'); o.className = 'cz-w';
              var s = d.createElement('span'); s.textContent = w; o.appendChild(s); frag.appendChild(o);
            });
            c.parentNode.replaceChild(frag, c);
          } else if (c.nodeType === 1) walk(c);
        });
      };
      walk(h);
      h.querySelectorAll('.cz-w > span').forEach(function (s, i) { s.style.transitionDelay = (i * 55) + 'ms'; });
    });

    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; cio.unobserve(e.target);
        var el = e.target, txt = el.textContent, m = txt.match(/(\d+)/);
        if (!m || reduce) return;
        var end = parseInt(m[1], 10), t0 = null, dur = 1200;
        var step = function (t) {
          if (!t0) t0 = t; var k = Math.min(1, (t - t0) / dur); k = 1 - Math.pow(1 - k, 3);
          el.textContent = txt.replace(m[1], Math.round(end * k)); if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    d.querySelectorAll('.cz-stat b, [data-count]').forEach(function (el) { cio.observe(el); });

    var px = Array.prototype.slice.call(d.querySelectorAll('[data-parallax]'));
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var vh = window.innerHeight;
        px.forEach(function (el) {
          var r = el.getBoundingClientRect(); if (r.bottom < -200 || r.top > vh + 200) return;
          var f = parseFloat(el.dataset.parallax) || 0.15;
          var c = (r.top + r.height / 2 - vh / 2);
          el.style.transform = 'translate3d(0,' + (-c * f).toFixed(1) + 'px,0)';
        });
        d.querySelectorAll('.cz-scale-in').forEach(function (el) {
          var r = el.getBoundingClientRect(); var k = 1 - Math.min(1, Math.max(0, (r.top) / vh));
          el.style.setProperty('--cz-k', k.toFixed(3));
        });
        var bar = d.querySelector('.cz-progress');
        if (bar) { var h = d.documentElement.scrollHeight - vh; bar.style.transform = 'scaleX(' + (h > 0 ? window.scrollY / h : 0) + ')'; }
        ticking = false;
      });
    }
    if (!reduce) { window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }

    if (!reduce && window.matchMedia('(hover:hover)').matches) {
      d.querySelectorAll('[data-tilt]').forEach(function (el) {
        var wrap = el.parentElement;
        wrap.addEventListener('mousemove', function (ev) {
          var r = wrap.getBoundingClientRect();
          var x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
          el.style.transform = 'perspective(900px) rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 10) + 'deg) scale(1.03)';
        });
        wrap.addEventListener('mouseleave', function () { el.style.transform = ''; });
      });
    }

    d.querySelectorAll('.czst').forEach(function (st) {
      var chaps = st.querySelectorAll('.czst__ch'), imgs = st.querySelectorAll('.czst__img'), dots = st.querySelectorAll('.czst__dot');
      var set = function (i) {
        chaps.forEach(function (c, j) { c.classList.toggle('is-on', j === i); });
        imgs.forEach(function (c, j) { c.classList.toggle('is-on', j === i); });
        dots.forEach(function (c, j) { c.classList.toggle('is-on', j <= i); });
        st.style.setProperty('--czst-p', chaps.length > 1 ? i / (chaps.length - 1) : 1);
      };
      var sio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) set(Array.prototype.indexOf.call(chaps, e.target)); });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      chaps.forEach(function (c) { sio.observe(c); });
      set(0);
    });

    var edit = root.classList.contains('cz-edit');
    d.querySelectorAll('.czx-light').forEach(function (t) {
      if (t.dataset.lit) return; t.dataset.lit = 1;
      var walk = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (c) {
          if (c.nodeType === 3) {
            var frag = d.createDocumentFragment();
            c.textContent.split(/(\s+)/).forEach(function (w) {
              if (!w) return;
              if (/^\s+$/.test(w)) { frag.appendChild(d.createTextNode(w)); return; }
              var s = d.createElement('span'); s.className = 'czx-lw'; s.textContent = w; frag.appendChild(s);
            });
            c.parentNode.replaceChild(frag, c);
          } else if (c.nodeType === 1 && !c.classList.contains('czx-pill')) walk(c);
        });
      };
      walk(t);
    });
    var pins = Array.prototype.slice.call(d.querySelectorAll('[data-pin]'));
    if (pins.length && !reduce && !edit) {
      var sizeH = function () {
        pins.forEach(function (el) {
          var hs = el.querySelector('[data-hscroll]');
          if (hs) { var dist = Math.max(0, hs.scrollWidth - window.innerWidth); el._dist = dist; el.style.height = (window.innerHeight + dist) + 'px'; }
        });
      };
      var sTick = false;
      var scrub = function () {
        if (sTick) return; sTick = true;
        requestAnimationFrame(function () {
          var vh = window.innerHeight;
          pins.forEach(function (el) {
            var r = el.getBoundingClientRect(); if (r.bottom < -50 || r.top > vh + 50) return;
            var total = r.height - vh; var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
            el.style.setProperty('--p', p.toFixed(4));
            if (el._dist != null) { var hs = el.querySelector('[data-hscroll]'); hs.style.transform = 'translate3d(' + (-el._dist * p).toFixed(1) + 'px,0,0)'; }
            var ws = el._ws || (el._ws = el.querySelectorAll('.czx-lw'));
            if (ws.length) { var n = Math.round(Math.min(1, p * 1.3) * ws.length); for (var i = 0; i < ws.length; i++) ws[i].classList.toggle('on', i < n); }
          });
          sTick = false;
        });
      };
      sizeH(); scrub();
      window.addEventListener('scroll', scrub, { passive: true });
      window.addEventListener('resize', function () { sizeH(); scrub(); });
      window.addEventListener('load', function () { sizeH(); scrub(); });
    }
    if (!d.querySelector('.cz-progress')) { var pb = d.createElement('div'); pb.className = 'cz-progress'; d.body.appendChild(pb); onScroll && onScroll(); }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
